document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("leadPopup");
    const closeBtn = document.getElementById("closeLeadPopup");
    const unlockBtn = document.getElementById("unlockDiscount");
    const mobileInput = document.getElementById("leadMobile");
    const error = document.getElementById("leadError");

    let currentForm = null;

    // Returning customer - skip popup
    if (localStorage.getItem("secretEyeLead") === "true") {
        return;
    }

    // Intercept Add to Cart
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {

        form.addEventListener("submit", function (e) {

            e.preventDefault();

            currentForm = this;

            popup.style.display = "flex";

        });

    });

    // Close popup
    closeBtn.addEventListener("click", () => {

        popup.style.display = "none";

    });

    popup.addEventListener("click", (e) => {

        if (e.target === popup) {

            popup.style.display = "none";

        }

    });

    unlockBtn.addEventListener("click", async () => {

        error.textContent = "";

        const mobile = mobileInput.value.trim();

        if (!/^[6-9]\d{9}$/.test(mobile)) {

            error.textContent = "Please enter a valid 10 digit mobile number.";

            return;

        }

        unlockBtn.disabled = true;

        unlockBtn.innerHTML = "Please wait...";

        try {

            // Get selected variant
            const cartForm = new FormData(currentForm);

            const variantId = cartForm.get("id");

            // Product title
            let productName = document.title;

            const heading = document.querySelector("h1");

            if (heading) {

                productName = heading.innerText.trim();

            }

            // Google Sheet Data
            const leadData = new FormData();

            leadData.append("mobile", mobile);
            leadData.append("product", productName);
            leadData.append("productId", variantId);

            // Save Lead
            await fetch("https://script.google.com/macros/s/AKfycbzz6BdImkYaGbDFaVp-mCfU5tMArb0Mc-ADRsl9ombXb0KUOY1tbo-0QDaQoKOLXaLBlQ/exec", {

                method: "POST",

                body: leadData,

                mode: "no-cors"

            });

            // Save browser state
            localStorage.setItem("secretEyeLead", "true");

            // Add Product
            await fetch("/cart/add.js", {

                method: "POST",

                headers: {

                    "Content-Type": "application/json"

                },

                body: JSON.stringify({

                    id: variantId,

                    quantity: 1

                })

            });

            // Hide popup
            popup.style.display = "none";

            // Redirect with Discount
            window.location.href = "/discount/WELCOME10?redirect=/cart";

        }

        catch (err) {

            console.error(err);

            error.textContent = "Something went wrong. Please try again.";

            unlockBtn.disabled = false;

            unlockBtn.innerHTML = "Register";

        }

    });

});